import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import ResultOfApartmentContainer from '../components/ResultOfApartmentContainer';
import Spin from '../components/Spin';
import { columnOrderForAptInfo, columnOrderForAptA1B1Info } from '../constant/columnsName';
import SaleModal from '../components/SaleModal';
import BookmarkModal from '../components/BookmarkModal';
import { useApiContext } from '../context/ApiContext';
import { useBodyScrollLock } from '../hooks/useBodyScrollLock';
import { useAptSaleInfo } from '../hooks/useAptSaleInfo';

const ApartmentDetail = () => {
  const { aptNo, pyeongNo } = useParams();
  const [aptInfo, setAptInfo] = useState(null);
  const [isFetchingAptInfo, setIsFetchingAptInfo] = useState(false);
  const [aptInfoFetchError, setAptInfoFetchError] = useState(false);

  const [showBookmark, setShowBookmark] = useState(false);
  const { api } = useApiContext();
  const {
    aptA1B1ListInfo, isFetchingAptA1B1Info, aptA1B1InfoFetchError,
    showSaleModal, setShowSaleModal, modalIsRent, pyeongName, handleSaleClick,
  } = useAptSaleInfo(api);

  useBodyScrollLock(showSaleModal);

  // 기존 URL의 rent 파라미터는 더 이상 기본값으로 사용하지 않음
  // const isRent = searchParams.get('rent') === 'true';

  useEffect(() => {
    if (aptNo) {
      getAptInfo(aptNo);
    }
    // 기존에 aptA1B1 매물정보를 기본 호출하던 코드를 삭제:
    // if (aptNo && pyeongNo) {
    //   getAptListA1B1Info(aptNo, pyeongNo, isRent);
    // }
  }, [aptNo]);

  const getAptInfo = async (apt_no) => {
    setIsFetchingAptInfo(true);
    
    try {
      const { data, error } = await api.getAptInfo(apt_no);
      
      if (error) {
        console.error('아파트 정보 조회 오류:', error);
        setAptInfoFetchError(true);
        setAptInfo(null);
        return;
      }
      
      setAptInfo(data);
      setAptInfoFetchError(false);
    } catch (error) {
      console.error('아파트 정보 조회 중 오류 발생:', error);
      setAptInfoFetchError(true);
      setAptInfo(null);
    } finally {
      setIsFetchingAptInfo(false);
    }
  };

  if (isFetchingAptInfo) {
    return (
      <div className="flex justify-center items-center p-8">
        <Spin size={32} /><span className="ml-3 text-gray-700 text-3xl md:text-3xl text-xl">아파트 정보 불러오는 중...</span>
      </div>
    );
  }

  if (aptInfoFetchError) {
    return (
      <div className='m-1 p-2 text-center'>
        <p className='text-2xl mb-4'>아파트 정보를 찾을 수 없습니다. 올바른 아파트 번호인지 확인해주세요.</p>
        <Link to="/" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
          홈으로 돌아가기
        </Link>
      </div>
    );
  }

  return (
    <div className='m-1 p-1.5 max-w-full'>
      {aptInfo && (
        <div className="flex justify-end mb-2 px-1">
          <button
            onClick={() => setShowBookmark(true)}
            className="px-4 py-2 text-sm bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            이 단지 알림 받기
          </button>
        </div>
      )}

      <ResultOfApartmentContainer 
        isFetchingAptInfo={isFetchingAptInfo}
        aptInfoFetchError={aptInfoFetchError}
        aptInfo={aptInfo}
        columnOrderForAptInfo={columnOrderForAptInfo}
        onSaleClick={handleSaleClick}
      />

      <SaleModal
        showSaleModal={showSaleModal}
        modalIsRent={modalIsRent}
        setShowSaleModal={setShowSaleModal}
        isFetchingAptA1B1Info={isFetchingAptA1B1Info}
        aptA1B1InfoFetchError={aptA1B1InfoFetchError}
        aptA1B1ListInfo={aptA1B1ListInfo}
        columnOrderForAptA1B1Info={columnOrderForAptA1B1Info}
        aptNo={aptNo}
        pyeongName={pyeongName}
      />

      <BookmarkModal
        isOpen={showBookmark}
        onClose={() => setShowBookmark(false)}
        onConfirm={async (data) => {
          const { error } = await api.addWatchlistApartment(data);
          if (!error) setShowBookmark(false);
        }}
        apartmentName={aptInfo?.apartment_name ?? aptInfo?.aptNm ?? ''}
        aptNo={aptNo}
        availableAreas={aptInfo?.areas ?? (aptInfo?.exclusive_area ? [aptInfo.exclusive_area] : [])}
      />
    </div>
  );
};

export default ApartmentDetail;